import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ArrowLeftBlack, ArrowRightBlack, CloseIcon } from 'assets/icons';
import { ClientQuoteService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalChangeDate extends React.Component<Props> {

	calendar: any;

	state = {
		item: this.props.item,
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		holidays: [],
		journeys: [],
		quotes: [],
		form: {
			date: moment(this.props.item?.date).format('YYYY-MM-DD'),
			journey_id: this.props.item?.journey_id
		},
		loading_journeys: false
	}

	componentDidMount() {
		window.dispatchEvent(new Event('resize'));

		this.load();
	}

	load = async () => {
		const res: any = await ClientQuoteService.client.getHolidays({
			service_id: this.props.item?.service_id
		});
		this.setState({
			holidays: res.holidays
		},() => {
			this.loadJourneys();
			this.loadQuotesMonth();
		});
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		},() => {
			this.loadQuotesMonth();
		});
	}

	submit = async () => {
		const res: any = await ClientQuoteService.client.editDate({
			...this.state.form,
			quote_id: this.props.item?.id
		});
		this.props.onClose(true,res.quote);
	}

	loadJourneys = async () => {
		await this.setState({
			loading_journeys: true
		});
		const res: any = await ClientQuoteService.client.getJourneys({
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.item?.service_id,
			withoutLoading: true
		});
		this.setState({
			journeys: res.journeys,
			loading_journeys: false
		});
	}

	loadQuotesMonth = async () => {
		const res: any = await ClientQuoteService.client.getQuotesMonth({
			date: moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').startOf('month').format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.item?.service_id,
			withoutLoading: true
		});
		this.setState({
			quotes: res.quotes
		});
	}
	
	render() {
		const holidays: any = this.state.holidays || [];
		const { quotes } = this.state;
		const journeys: any = this.state.journeys.filter((i: any) => {
			const service_journey = this.state.item?.service?.service_journeys?.find((item: any) => item.journey_id == i.id);

			if (i.quantity >= service_journey?.quantity) {
				if (this.state.item?.journey_id == i.id && this.state.form.date == moment(this.state.item?.date).format('YYYY-MM-DD')) {
					return true;
				}
				else {
					return false;
				}
			}	

			return true;
		});

		return (
			<div id="modal-change-date">
				<div className="row">
					<div className="col-md-12">
						<div className="blue-container">
							<div className="row">
								<div className="col-12 text-center">
									<h3>Seleccione fecha disponible</h3>
									<div className="text-right btn-close">
										<button className="btn" onClick={ () => this.props.onClose() }>
											<img src={ CloseIcon } />
										</button>
									</div>
								</div>
							</div>
							
							<div className="row">
								<div className="col-lg-6">
									<div className="container-arrow">
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().prevYear();
											this.updateDate();
										} }>
											<img src={ ArrowLeftBlack } />
										</button>
										<h4>{ this.state.currentYear }</h4>
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().nextYear();
											this.updateDate();
										} }>
											<img src={ ArrowRightBlack } />
										</button>
									</div>
								</div>
								<div className="col-lg-6">
									<div className="container-arrow">
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().prev();
											this.updateDate();
										} }>
											<img src={ ArrowLeftBlack } />
										</button>
										<h4>{ this.state.currentMonth }</h4>
										<button className="btn btn-arrow" onClick={ () => {
											this.calendar.getApi().next();
											this.updateDate();
										} }>
											<img src={ ArrowRightBlack } />
										</button>
									</div>
								</div>
							</div>

							<FullCalendar
								ref={ ref => this.calendar = ref }
						        plugins={[ dayGridPlugin ]}
						        initialView="dayGridMonth"
						        locale="es"
						        dayHeaderContent={ (args: any) => {
						        	return (
						        		<button className="btn day-container day-header">
											<p>{ args.text.substring(0,2) }</p>
					        			</button>
						        	)
						        } }
					        	dayCellContent={ (info) => {
					        		const date = moment(info.date).format('YYYY-MM-DD');
					        		const journeys: any = this.state.journeys.filter((i: any) => {
										const service_journey = this.state.item?.service?.service_journeys?.find((item: any) => item.journey_id == i.id);

										if (quotes.filter((item: any) => item.journey_id == i.id && moment(item.date).format('YYYY-MM-DD') == date).length >= service_journey?.quantity) {
											return false;
										}	

										return true;
									});

					        		return (
					        			<button disabled={ 
					        				(date == moment().format('YYYY-MM-DD') || 
					        				date == moment().add(1,'day').format('YYYY-MM-DD') || 
					        				date < moment().format('YYYY-MM-DD') || 
					        				date > moment().add(6,'months').format('YYYY-MM-DD') || 
					        				holidays.indexOf(date) != -1) &&
					        				date != moment(this.state.item?.date).format('YYYY-MM-DD')					        				
					        			} 
					        			className={ `btn day-container ${ this.state.form.date == date ? 'active' : '' } ${ (holidays.indexOf(date) != -1 || (journeys.length == 0 && date != moment(this.state.item?.date).format('YYYY-MM-DD'))) ? 'holiday' : '' }` } 
					        			onClick={ () => this.setState({
					        				form: {
					        					...this.state.form,
					        					date
					        				}
					        			},() => this.loadJourneys()) }>
											<p>{ moment(info.date).format('D') }</p>
					        			</button>
					        		)
					        	} }
						        headerToolbar={{
						        	left: '',
						        	center: '',
						        	right:  ''
						        }}
						    />

						    <div className="row row-colors">
						    	<div className="col-12">
						    		<div className="item-color">
							    		<div className="container-green"></div>
							    		<p>Con disponibilidad</p>
						    		</div>
						    	</div>
						    	<div className="col-12">
						    		<div className="item-color">
							    		<div className="container-red"></div>
							    		<p>Sin disponibilidad</p>
							    	</div>
						    	</div>
						    </div>

						    <div className="text-center">
								<button className="btn btn-green" onClick={ () => this.submit() }>
									Siguiente
								</button>		
							</div>
						</div>
					</div>
					{/*<div className="col-md-6">
						<div className="white-container">
							<div className="row">
								<div className="col-12 text-center">
									<h3>Seleccione horario disponible</h3>
									<div className="text-right btn-close">
										<button className="btn" onClick={ () => this.props.onClose() }>
											<img src={ CloseIcon } />
										</button>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-8" style={{ display: 'flex', alignItems: 'flex-end' }}>
									<h5>Jornadas</h5>
								</div>
								<div className="col-4" style={{ display: 'flex', alignItems: 'flex-end' }}>
									<h5>Reservas disponibles</h5>
								</div>

								{
									this.state.loading_journeys && (
										<div className="text-center">
											<i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" />
										</div>
									)
								}

								{
									journeys.map((item: any) => {
										const service_journey = this.state.item?.service?.service_journeys?.find((i: any) => i.journey_id == item.id);
										let quantity = quotes.filter((i: any) => i.journey_id == item.id && moment(i.date).format('YYYY-MM-DD') == this.state.form.date).length;
										quantity = service_journey?.quantity - quantity;

										if (moment(this.state.item?.date).format('YYYY-MM-DD') == this.state.form.date && this.state.item?.journey_id == item.id) {
											quantity++;
										}

										return (
											<React.Fragment>
												<div className="col-8">
													<div className="item-journey" onClick={ () => this.setState({
														form: {
															...this.state.form,
															journey_id: item.id
														}
													}) }>
														<div className={ `check ${ this.state.form.journey_id == item.id ? 'active' : '' }` }></div>
														<div>
															<p>{ item.name }</p>
															<p>{ moment(item?.since,'HH:mm:ss').format('hh:mm a') } - { moment(item?.until,'HH:mm:ss').format('hh:mm a') }</p>
														</div>
													</div>
												</div>
												<div className="col-4 text-center disponibility">
													<Input
														color="white"
														value={ quantity < 0 ? 0 : quantity }
														disabled={ true } />
												</div>
											</React.Fragment>
										)
									})
								}

								{
									journeys.length == 0 && (
										<p className="no-journeys">Lo sentimos, no hay jornadas disponibles para este día</p>
									)
								}
							</div>

							<div className="text-center">
								<button className="btn btn-green" onClick={ () => this.submit() }>
									Siguiente
								</button>		
							</div>						
						</div>
					</div>*/}
				</div>
			</div>
		)
	}
}

export default ModalChangeDate;